
<section class="points__transport-list-card-wrapper">
  @if (transportList() && transportList().length > 0) {
    
    <div 
      [class]="'points__transport-list-card' + ' ' + status()" 
      [style.--height]="maxHeight()"
      [attr.data-is-overflow]="isOverflow()"
    >
      @for (transport of transportList(); track transport.id; let i = $index) {
        
        @if (isOverflow()) {
          <app-transport-list-card-overflow-line-list
            [lineHeight]="marginBottomTransportList()[i]"
            [iconName]="transport.iconName"
            [status]="status()"
            [isFirst]="i === 0"
            [isLast]="i === transportList().length - 1"
          />
          
        } @else {
          <app-transport-list-card-standard-transfer
            [lineHeight]="marginBottomTransportList()[i]"
            [transportList]="transportList()"
            [transport]="transport"
            [pointTitle]="pointTitle()"
            [previousPointTitle]="previousPointTitle()"
            [status]="status()"
          />
        }
      }
    </div>
  }

  @if(isOverflow()) {
    <app-transport-list-card-icon-list-overflow
      [transportList]="transportList()"
      [pointTitle]="pointTitle()"
      [previousPointTitle]="previousPointTitle()"
      [status]="status()"
    />
  }
<section>

